<template>
  <v-card flat :loading="load">
    <!-- <v-card-title class="headline primary white--text">
      Questionário Psicossocial
    </v-card-title> -->

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>

        <!-- Questões principais -->
        <v-subheader class="mt-4">Questões Psicossociais</v-subheader>
        <v-row v-for="(question, index) in mainQuestions" :key="'main-' + index">
          <v-col cols="12">
            <v-row>
              <v-col cols="8">
                <div class="question-text">{{ index + 1 }}. {{ question.text }}</div>
              </v-col>
              <v-col cols="4">
                <v-radio-group v-model="formData[question.field]" row dense class="mt-0">
                  <v-radio label="Não" value="NAO"></v-radio>
                  <v-radio label="Sim" value="SIM"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
        </v-row>

        <!-- Questões complementares -->
        <v-subheader class="mt-4">Questões Complementares</v-subheader>
        <v-row v-for="(question, index) in complementaryQuestions" :key="'comp-' + index">
          <v-col cols="12">
            <v-row>
              <v-col cols="8">
                <div class="question-text">{{ question.text }}</div>
              </v-col>
              <v-col cols="4">
                <v-radio-group v-model="formData[question.field]" row dense class="mt-0">
                  <v-radio label="Não" value="NAO"></v-radio>
                  <v-radio label="Sim" value="SIM"></v-radio>
                  <v-radio label="Ignorado" value="IGNORADO"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :loading="load" text color="red" @click="$emit('voltar', 'voltar')">
            <v-icon left color="red">keyboard_return</v-icon>
            cancelar</v-btn>
      <v-btn color="primary" @click="submit" :disabled="!valid" :loading="load">
        Salvar
      </v-btn>
      <v-btn color="secondary" @click="reset">
        Limpar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import medicoService from '../../services/medico.service'

export default {
  props: {
    idExamesOS: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      load: false,
      formData: {
        id: null,
        data_registro: new Date().toISOString(),
        idExamesOs: null,
        // Campos para as questões psicossociais
        dorCabecaFrequente: null,
        faltaApetite: null,
        dormeMal: null,
        assustaFacil: null,
        tremoresMao: null,
        senteNervoso: null,
        maDigestao: null,
        dificuldadePensar: null,
        senteTriste: null,
        choroExcessivo: null,
        dificuldadeAtividades: null,
        dificuldadeDecisoes: null,
        dificuldadeServico: null,
        incapazPapelUtil: null,
        perdaInteresse: null,
        senteInutil: null,
        ideiasSuicidas: null,
        cansadoTodoTempo: null,
        sensacaoEstomago: null,
        cansaFacil: null,
        medoAltura: null,
        medoEspacosFechados: null,
        dificuldadeEquilibrio: null,
        teveConvulsoes: null,
        jaDesmaiou: null
      },
      mainQuestions: [
        { text: 'Tem dores de cabeça frequentes?', field: 'dorCabecaFrequente' },
        { text: 'Tem falta de apetite?', field: 'faltaApetite' },
        { text: 'Dorme mal?', field: 'dormeMal' },
        { text: 'Assuste-se com facilidade?', field: 'assustaFacil' },
        { text: 'Tem tremores de mão?', field: 'tremoresMao' },
        { text: 'Sente-se nervoso(a), tenso(a) ou preocupado(a)?', field: 'senteNervoso' },
        { text: 'Tem má digestão?', field: 'maDigestao' },
        { text: 'Tem dificuldade de pensar com clareza?', field: 'dificuldadePensar' },
        { text: 'Tem se sentido triste ultimamente?', field: 'senteTriste' },
        { text: 'Tem chorado mais que de costume?', field: 'choroExcessivo' },
        { text: 'Tem dificuldade para realizar com satisfação suas atividades diárias?', field: 'dificuldadeAtividades' },
        { text: 'Tem dificuldades para tomar decisões?', field: 'dificuldadeDecisoes' },
        { text: 'Tem dificuldades no serviço (seu trabalho é penoso, causa sofrimento)?', field: 'dificuldadeServico' },
        { text: 'É incapaz de desempenhar um papel útil em sua vida?', field: 'incapazPapelUtil' },
        { text: 'Tem perdido o interesse pelas coisas?', field: 'perdaInteresse' },
        { text: 'Você se sente uma pessoa inútil, sem préstimo?', field: 'senteInutil' },
        { text: 'Você tem tido ideias de acabar com a vida?', field: 'ideiasSuicidas' },
        { text: 'Sente-se cansado(a) o tempo todo?', field: 'cansadoTodoTempo' },
        { text: 'Tem sensações desagradáveis no estômago?', field: 'sensacaoEstomago' },
        { text: 'Você se cansa com facilidade?', field: 'cansaFacil' }
      ],
      complementaryQuestions: [
        { text: 'Você tem medo de altura?', field: 'medoAltura' },
        { text: 'Você tem medo de espaços fechados?', field: 'medoEspacosFechados' },
        { text: 'Você tem ou já teve alguma dificuldade de equilíbrio?', field: 'dificuldadeEquilibrio' },
        { text: 'Você já teve convulsões?', field: 'teveConvulsoes' },
        { text: 'Você já desmaiou por algum motivo?', field: 'jaDesmaiou' }
      ]
    }
  },
  methods: {
    cadastrarAvaliacaoPsicosocial (data) {
      this.load = true
      medicoService.medico.cadastrarAvaliacaoPsicosocial(data).then(response => {
        if (response.status === 200) {
          this.$emit('voltar')
        }
      }).finally(() => {
        this.load = false
      })
    },
    buscarAvaliacaoPsicosocial () {
      this.load = true
      medicoService.medico.buscarAvaliacaoPsicosocial(this.idExamesOS).then(response => {
        if (response.status === 200) {
          // console.log(response.data)
          if (response.data.success) {
            this.formData = response.data.data
            console.log('formData', this.formData)
          }
        }
      }).finally(() => {
        this.load = false
      })
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.formData.idExamesOs = this.idExamesOS
        // Aqui você pode adicionar a lógica para enviar os dados para o servidor
        console.log('Dados do formulário:', this.formData)
        // alert('Formulário enviado com sucesso!')
        this.cadastrarAvaliacaoPsicosocial(this.formData)
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    loadData (data) {
      // Método para carregar dados existentes (para edição)
      this.formData = { ...this.formData, ...data }
    }
  },
  mounted () {
    if (this.idExamesOS) {
      this.buscarAvaliacaoPsicosocial()
    }
  }
}
</script>

<style scoped>
.question-text {
  font-weight: 500;
  margin-bottom: 8px;
}
</style>
